<template>
  <div class="modal fade" tabindex="-1" id="modalDefault">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <a href="#" class="close" data-dismiss="modal" aria-label="Close">
          <em class="icon ni ni-cross"></em>
        </a>
        <div class="modal-header">
          <h5 class="modal-title">Settings</h5>
        </div>
        <div class="modal-body">
          <form action="#" class="form-validate is-alter" novalidate="novalidate">
            <!-- Global Settings Toggle - Only for main chapters A-G -->
            <div v-if="isMainChapter && mode !== 'imageOnly'" class="form-group" style="border-bottom: 1px solid #e5e9f2; padding-bottom: 15px; margin-bottom: 20px;">
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="useGlobalSettings"
                  v-model="useGlobalSettings" />
                <label class="custom-control-label" for="useGlobalSettings">
                  <strong>Use Global Settings</strong>
                </label>
              </div>
              <small class="form-text text-muted">
                When enabled, this chapter will use the global settings. You can still override them by disabling this option.
              </small>
            </div>

            <!-- Settings Section (disabled when using global) -->
            <div :style="{ opacity: useGlobalSettings && mode !== 'imageOnly' ? 0.5 : 1 }">
              <div class="alert alert-info" v-if="useGlobalSettings && globalSettings && mode !== 'imageOnly'">
                <strong>Currently using global settings:</strong><br>
                New Page: {{ globalSettings.newpage ? 'Yes' : 'No' }}<br>
                Hide Progress Bar: {{ globalSettings.hideProgressBar ? 'Yes' : 'No' }}<br>
                Chapter Image: {{ globalSettings.chapterimage ? 'Yes' : 'No' }}
              </div>

            <div class="form-group">
              <div class="row gy-4">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="form-label" for="default-01">Localisation picture</label>
                    <div class="form-control-wrap">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="customCheck1"
                          v-model="chapterEntry.chapterimage" :disabled="useGlobalSettings && mode !== 'imageOnly'" />
                        <label class="custom-control-label" for="customCheck1">Chapter with image</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group" v-if="chapterEntry.chapterimage && mode !== 'imageOnly'">
                    <label class="form-label" for="default-01">&nbsp;</label>
                    <div class="form-control-wrap">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="customCheck2"
                          v-model="chapterEntry.chapterincludes" :disabled="useGlobalSettings" />
                        <label class="custom-control-label" for="customCheck2">includes all following chapters</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" v-if="chapterEntry.chapterimage">
              <div class="row gy-4">
                <div class="col-sm-6">
                  <select class="form-control" v-model="chapterEntry.chapterfile" :disabled="useGlobalSettings && mode !== 'imageOnly'">
                    <option :value="item.file" v-for="item in imglib_list" :key="item.uid">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6" v-if="mode !== 'imageOnly'">
                  <div class="form-control-wrap">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="customCheck9"
                        v-model="chapterEntry.chapterV" :disabled="useGlobalSettings" />
                      <label class="custom-control-label" for="customCheck9">show V (OK) on image</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" v-if="mode !== 'imageOnly'">
              <div class="row gy-4">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="form-label" for="default-01">Format</label>
                    <div class="form-control-wrap">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="customCheck3"
                          v-model="chapterEntry.newpage" :disabled="useGlobalSettings" />
                        <label class="custom-control-label" for="customCheck3">Chapter on new page</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="form-label" for="default-01">&nbsp;</label>
                    <div class="form-control-wrap">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="customCheck10"
                          v-model="chapterEntry.hideProgressBar" :disabled="useGlobalSettings" />
                        <label class="custom-control-label" for="customCheck10">Hide progress bar (Construction Progress
                          Monitoring)</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div><!-- End of disabled section -->
            <div class="form-group" style="margin-top: 30px">
              <button type="button" style="text-align:center;width: 100%;" class=" btn-lg btn-primary"
                @click="updateSettings">
                Save
              </button>
            </div>
          </form>
        </div>
        <div class="modal-footer bg-light"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getChapterSettings,
  saveChapterSettings,
  getGlobalChapterSetting,
} from "@/services/reporting-v3.service";

export default {
  props: ["chapterId", "projectNumber", "inspectionEntry", "projectUid", "mode"],
  data() {
    return {
      chapterEntry: {},
      useGlobalSettings: false,
      globalSettings: null,
    };
  },
  computed: {
    imglib_list: function () {
      return this.$store.state.rp_imglib;
    },
    isMainChapter: function () {
      // List of main chapter IDs
      const mainChapterIds = [
        'inspectionDetails',
        'general',
        'machinedata',
        'components',
        'findings',
        'conclusion',
        'disclaimer',
        'generalB1',
        'generalB2',
        'generalB3',
        'generalB4',
        'generalB5'
      ];

      // Check if this chapter's ID is in the main chapters list
      // Try to extract the base ID from complex IDs like 'general0', 'findings3', etc.
      let baseId = this.chapterId.id;

      // Remove trailing numbers from IDs like 'general0' -> 'general'
      const cleanId = baseId ? baseId.replace(/\d+$/, '') : null;

      return mainChapterIds.includes(cleanId) || mainChapterIds.includes(baseId);
    },
  },
  mounted() {
    $("#modalDefault").modal("show");

    const ref = this;

    $("#modalDefault").on("hidden.bs.modal", function () {
      ref.$emit("dialogClosed");
    });

    this.chapterEntry = {
      chapterimage: false,
      chapterV: false,
      newpage: false,
    };

    let chapter_uid = "";

    if (this.chapterId.chapter && this.chapterId.chapter.length > 0) {
      chapter_uid += this.chapterId.chapter + "-";
    }

    // Load global settings (only for main chapters)
    if (this.isMainChapter) {
      // Get the clean chapter ID
      const cleanId = this.chapterId.id ? this.chapterId.id.replace(/\d+$/, '') : null;

      getGlobalChapterSetting(cleanId).then((globalData) => {
        if (globalData && globalData.data && globalData.data.settings) {
          this.globalSettings = globalData.data.settings;
        }
      }).catch(() => {
        // Global settings not found, that's okay
        this.globalSettings = null;
      });
    }

    getChapterSettings(
      this.projectNumber,
      this.inspectionEntry.uid,
      chapter_uid + "" + this.chapterId.level + "-" + this.chapterId.title.text,
      this.projectUid
    ).then((d) => {
      if (d) {
        if (d.data && d.data.imglib) {

          this.$store.state.rp_imglib = []

          for (let i = 0; i < d.data.projectlib.length; i++) {
            this.$store.state.rp_imglib.push({
              uid: d.data.projectlib[i].uid,
              name: d.data.projectlib[i].name,
              file: d.data.projectlib[i].file,
              width: d.data.projectlib[i].width,
              height: d.data.projectlib[i].height,
              cat: 'projectlib'
            });
          }

          for (let i = 0; i < d.data.imglib.length; i++) {
            this.$store.state.rp_imglib.push({
              uid: d.data.imglib[i].uid,
              name: d.data.imglib[i].name,
              file: d.data.imglib[i].file,
              width: d.data.imglib[i].width,
              height: d.data.imglib[i].height,
              cat: 'image-lib'
            });
          }

          //this.$store.state.rp_imglib = d.data.imglib;
        }

        if (d.data && d.data.chapter) {
          this.chapterEntry = d.data.chapter;
          // Check if this chapter uses global settings
          if (d.data.chapter.useGlobalSettings !== undefined) {
            this.useGlobalSettings = d.data.chapter.useGlobalSettings;
          }
        }
      }
    });

    // ------
  },
  methods: {
    updateSettings: async function () {


      // Chapter UID

      let chapter_uid = "";

      if (this.chapterId.chapter && this.chapterId.chapter.length > 0) {
        chapter_uid += this.chapterId.chapter + "-";
      }

      if (this.chapterEntry.chapterfile) {
        console.log("ja ist ein file", this.chapterEntry)
        for (let n in this.$store.state.rp_imglib) {
          if (this.$store.state.rp_imglib[n].file == this.chapterEntry.chapterfile) {
            this.chapterEntry.file_cat = this.$store.state.rp_imglib[n].cat
            break;
          }
        }
      }

      // Add the useGlobalSettings flag to the settings
      this.chapterEntry.useGlobalSettings = this.useGlobalSettings;

      await saveChapterSettings(
        this.projectNumber,
        this.inspectionEntry.uid,
        chapter_uid +
        "" +
        this.chapterId.level +
        "-" +
        this.chapterId.title.text,
        this.chapterEntry
      ).then((d) => {
        this.$store.state.rp_chapters_settings = d.data.chapters_settings;

        this.$store.state.chapters_settings = d.data.chapters_settings;
        $("#modalDefault").modal("hide");
      });
    },
  },
};
</script>

<style></style>